module.exports = __webpack_public_path__ + "img/leftovers.53e7c943.png";